import {
  WithStyles,
  Grid,
  Theme,
  Checkbox,
  Typography
} from '@material-ui/core'
import ThumbUpIcon from '@material-ui/icons/ThumbUp'
import { withStyles } from '@material-ui/styles'
import i18n from 'i18next'
import moment from 'moment'
import { FC, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { OpenDialog } from '../../../../actions/types'
import { selectDialogVisibility } from '../../../../selectors/dialogs'
import { getCurrentLanguage } from '../../../../translations/i18n'
import { ReservableShowing } from '../../../../types/showings'
import { UpdateStatusDialog } from '../UpdateStatus'

const styles = ({ breakpoints }: Theme) => ({
  reservableCardContainer: {
    width: '100%',
    background: '#e7ecef',
    padding: '10px 0',
    display: 'flex',
    justifyContent: 'space-between',
    borderRadius: '5px',
    cursor: 'pointer'
  },
  reservableCardItem: {
    alignSelf: 'center',
    textAlign: 'center' as const,
    '&::first-letter': {
      textTransform: 'uppercase'
    }
  },
  cardCheckboxDisabled: {
    color: '#cfd7dc !important',
    '& > .MuiIconButton-label > svg': {
      height: '30px',
      width: '30px',
      background: 'white',
      clipPath: 'inset(14% 12% 12% 14%)'
    }
  },
  cardCheckboxActive: {
    color: '#4f9b44 !important',
    '& > .MuiIconButton-label > svg': {
      height: '30px',
      width: '30px'
    }
  },
  thumbUpIcon: {
    color: '#4f9b44'
  },
  iconContainer: {
    minWidth: '28px',
    paddingRight: '20px'
  },
  bestReservables: {
    fontSize: '12px',
    color: '#4f9b44',
    textTransform: 'none' as const
  },
  noAvailableTimesButton: {
    width: '100%'
  }
})

export interface ReservableCardProps extends WithStyles {
  showing?: ReservableShowing
  t: i18n.TFunction
  openDialog: OpenDialog
  isConfirmDialog?: true
  bestReservable?: any
  dialogVisibility: any
  reserveData?: any
}

const ReservableCard: FC<ReservableCardProps> = ({
  showing,
  classes,
  t,
  openDialog,
  isConfirmDialog,
  bestReservable,
  dialogVisibility,
  reserveData
}) => {
  useEffect(() => {
    if (!dialogVisibility.isVisible) setActive(false)
  }, [dialogVisibility.isVisible])
  const languageIsEN = getCurrentLanguage()
  moment.locale(languageIsEN)
  const date = showing && moment(showing.startDate).format('dddd DD.MM')
  const startTime = showing && moment(showing.startDate).format('HH.mm')

  const [active, setActive] = useState(false)
  return (
    <Grid
      container
      className={classes.reservableCardContainer}
      style={active ? { background: '#e6ffe2' } : {}}
      onClick={() => {
        if (!active) {
          if (showing) {
            openDialog(`ReserveConfirmationDialog${showing.showingId}`)
          } else {
            openDialog(`ConfirmNoAvailableTimes`)
          }
        }
        setActive(!active)
      }}
    >
      <Grid item>
        <Checkbox
          checked={active}
          onChange={() => {
            setActive(!active)
          }}
          className={
            active ? classes.cardCheckboxActive : classes.cardCheckboxDisabled
          }
        />
      </Grid>
      <Grid item className={classes.reservableCardItem}>
        {showing ? (
          <Typography variant='body1'>
            {`${date} ${t('atTime')} `}
            {startTime}
          </Typography>
        ) : (
          <div>
            <Typography variant='body1'>
              {t('showings.reserve.updateStatus.noAvailableTimes.button')}
            </Typography>
            <UpdateStatusDialog
              status={'noAvailableTimes'}
              noReservablesCase={false}
              t={t}
              noOpenDialogButton
            />
          </div>
        )}

        {showing &&
          bestReservable &&
          (bestReservable.includes(showing.showingId) ||
            reserveData?.reservableShowings?.bestReservables?.some(
              (reservable) => reservable.startDate === showing.startDate
            )) ? (
          <Typography variant='body2' className={classes.bestReservables}>
            {t('showings.reserve.bestReservables')}
          </Typography>
        ) : (
          <></>
        )}
      </Grid>
      <Grid item className={classes.reservableCardItem}>
        <div className={classes.iconContainer}>
          {showing &&
            bestReservable &&
            (bestReservable.includes(showing.showingId) ||
              reserveData?.reservableShowings?.bestReservables?.some(
                (reservable) => reservable.startDate === showing.startDate
              )) ? (
            <ThumbUpIcon className={classes.thumbUpIcon} />
          ) : (
            <></>
          )}
        </div>
      </Grid>
    </Grid>
    // <Card className={classes.card}>
    //   <Grid container>
    //     <Grid item></Grid>
    //     <Grid item></Grid>
    //     <Grid item></Grid>
    //   </Grid>
    //   <Typography variant='h6' style={{ textAlign: 'center' }}>
    //     {t('showings.reserve.reserveTime')}
    //   </Typography>
    //   <ShowingCard showing={showing} useCase={'empty'} t={t} />
    //   {!isConfirmDialog && (
    //     <CardActions className={classes.cardActions}>
    //       <Button
    //         size='small'
    //         type='submit'
    //         variant='contained'
    //         color='primary'
    //         style={{ background: '#02CD98' }}
    //         fullWidth
    //         onClick={() =>
    //           openDialog(`ReserveConfirmationDialog${showing.showingId}`)
    //         }
    //       >
    //         {t('showings.reserve.reserve')}
    //       </Button>
    //     </CardActions>
    //   )}
    // </Card>
  )
}

const mapStateToProps = (state: { [key: string]: any }) => ({
  dialogVisibility: selectDialogVisibility(state)
})

export default connect(mapStateToProps)(withStyles(styles)(ReservableCard))
